import { useState, useEffect, useCallback } from 'react';

// Admin-tunable score threshold below which a chain stage raises a
// "Recent Alerts" pill. Persisted in localStorage (per browser) and
// broadcast so the strip and any control stay in sync. Default 80.
const KEY = 'mc.alertThreshold';
const EVENT = 'mc:alert-threshold';
const DEFAULT = 80;

export function getAlertThreshold() {
  try {
    const v = parseInt(localStorage.getItem(KEY), 10);
    return Number.isFinite(v) && v >= 0 && v <= 100 ? v : DEFAULT;
  } catch { return DEFAULT; }
}

export function setAlertThreshold(value) {
  const v = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
  try { localStorage.setItem(KEY, String(v)); } catch { /* noop */ }
  try { window.dispatchEvent(new CustomEvent(EVENT, { detail: v })); } catch { /* noop */ }
}

export function useAlertThreshold() {
  const [threshold, setThresholdState] = useState(getAlertThreshold);
  useEffect(() => {
    const onEvent = (e) => setThresholdState(e.detail);
    const onStorage = (e) => { if (e.key === KEY) setThresholdState(getAlertThreshold()); };
    window.addEventListener(EVENT, onEvent);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(EVENT, onEvent);
      window.removeEventListener('storage', onStorage);
    };
  }, []);
  const set = useCallback((v) => setAlertThreshold(v), []);
  return [threshold, set];
}

export default useAlertThreshold;
